import { Component, inject, Inject, Optional } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from '../services/notification.service';
import { Notification } from '../models/notification';
import { Location } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-machine',
  templateUrl: './notification.component.html',
  styleUrl: './notification.component.scss',
  standalone: false,

})
export class NotificationComponent {
  private notificationService = inject(NotificationService);
  private location = inject(Location);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  @Optional() private dialogRef = inject(MatDialogRef<NotificationComponent>, { optional: true });

  loading = false;
  notification?: Notification;
  dialogData: Notification | null = null;

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) data: Notification | null) {
    this.dialogData = data;
  }

  ngOnInit() {
    // If opened from dialog, use the provided data
    if (this.dialogData) {
      this.notification = this.dialogData;
      return;
    }

    this.route.paramMap.subscribe(params => {
      const notificationId = params.get('id');

      if (!notificationId) {
        return;
      }

      this.loading = true;
      this.notificationService.getNotification(notificationId).subscribe({
        next:(notification: Notification) => {
          this.notification = notification;
          this.loading = false;
        },
        error: (error) => {
          this.loading = false;
        }
      });
    });
  }

  goBack() {
    if (this.dialogRef) {
      this.dialogRef.close();
    } else {
      if (window.history.length > 1) {
        this.location.back();
      }
      else {
        // go to /dashboard/notifications
        this.router.navigate(['/dashboard/notifications']);
      }
    }
  }
}
